module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO10Actividad  (ant41).afb25fd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO10Actividad  (ant41).mp4
// module id = 736
// module chunks = 1